import { reactive } from "vue";
import { api, ChangePassword } from "~/api";
import { Log } from "~/extensions/utils";
const log = Log.create("PasswordChange");
class Store {
    changeHtml = "";
    completeHtml = "";
    async loadChangeHtml() {
        this.changeHtml = await api.password.changeHtml();
    }
    async loadCompleteHtml() {
        this.completeHtml = await api.password.completeHtml();
    }
    async update(query) {
        let result = await api.password.change(await ChangePassword.Create(query));
        return result;
    }
}
export let store = reactive(new Store());
